import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import { routes } from '../../assets/routes';
import { generatePath, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

// TODO: change it to scss
const useStyles = makeStyles(() => ({
  affected: {
    textAlign: 'start'
  }
}));

function ShowResultSearch(props) {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    props.customOnClick
      ? props.customOnClick()
      : history.push(generatePath(routes.PROFILE, { id: props.user.id }));
  };

  return (
    <>
      <ListItem onClick={handleClick} style={{ cursor: 'pointer' }}>
        <ListItemAvatar>
          <Avatar alt="" src={props.user.avatar?.thumbnail} />
        </ListItemAvatar>
        <ListItemText
          className={classes.affected}
          primary={`${props.user.first_name} ${props.user.last_name}`}
          secondary={
            props.user.organization_department
              ? `${props.user.organization_department.name}`
              : null
          }
        />
        {props.selected && <CheckCircleOutlineRoundedIcon />}
      </ListItem>
      <Divider variant="light" component="li" />
    </>
  );
}

ShowResultSearch.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    avatar: PropTypes.shape({
      thumbnail: PropTypes.string
    }),
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    organization_department: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  customOnClick: PropTypes.func,
  selected: PropTypes.bool
};

export default ShowResultSearch;
